import template from './factur-x-info.tpl.html';

export default {
	template,
	bindings: {
		tvaOrSiret: '@',
		dark: '@'
	}
};
